import React from "react";
import {observer} from "mobx-react";
import {Component} from "react";
import {receptionBunkersStore, transportStore} from "../../../../stores";
import localStyles from "../index.css";
import {RailCart, Truck} from "../../SubComponents";
import styles from "../../index.css";
import {Drag, Drop} from "../../../DragNDrop";
import TransportStack from "../TransportStack";
import ReceptionDispathcer from "../../../../stores/Dispatcher/ReceptionDispathcer";


@observer
export default class TransportField extends Component{
    state={
        dragItem: ''
    };

    deleteTransport(id){
        transportStore.removeTransport(id);
    }

    returnTransport(bunkerId,num){
        this.setState({dragItem:{bunkerId:bunkerId, num:num}})
    }

    onDrag(id){
        this.setState({dragItem:id})
    }


    render(){
        const bunker = receptionBunkersStore.receptionBunker;
        const trucks = transportStore.receptionTruck;
        const trains = transportStore.receptionTrain;
        return(
            <div className={localStyles.queues}>
                <div className={localStyles.bulkQueue}>
                    <div className={localStyles.railCartsBulkQueue}>
                        {trains.map((item,i)=>{
                            if (item.disabled){
                                return <div className={localStyles.activeTruck} style={{width:'9.0625rem',height: '3.125rem'}} key={i}/>
                            }
                            return(
                                <div key={i}>
                                    <RailCart item={item} />
                                </div>
                            )
                        })}
                    </div>
                    <div className={styles.trucksContainer}>
                        <Drop
                            className={styles.dropfieldBack}
                            onDrop={()=>{
                                ReceptionDispathcer.returnTransportFromBunkerStack(
                                this.state.dragItem.bunkerId,
                                this.state.dragItem.num
                            )}}
                            type={"back"}
                        >
                            <div className={localStyles.dropPlaceBack + ' ' + localStyles.activeTruck} />
                        </Drop>
                        <div className={localStyles.trucksBulkQueue}>
                            {trucks.map((item,i)=>{
                                return(
                                    <Drag type={"truck"} maskClassName={styles.transportMask}
                                          onDrag={this.onDrag.bind(this,i)}
                                          key={i}>
                                        <Truck
                                            item={item}
                                            id={i}
                                            deleteTransport={this.deleteTransport.bind(this)}
                                        />
                                    </Drag>
                                )
                            })}
                        </div>
                    </div>
                </div>
                <div className={localStyles.nearestQueue}>
                    {bunker.map((item,i)=>{
                        return <TransportStack returnTransport={this.returnTransport.bind(this)}
                                               transportDrop={this.state.dragItem}
                                               item={item} num={i} key={i}/>
                    })}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/shared/components/Game/InputFlow/TransportField/index.js